import useSWR, { type SWRConfiguration, useSWRConfig } from 'swr';
import type {
  HandlersSimCountResponse,
  StructsSimRequestProperties,
} from 'types/__generated__/SimInventoryApi';
import postFetcher from '../utils/postFetcher';
import { ApiBaseError } from '../utils/shared';

export interface SimsCountResultError extends ApiBaseError {}

type SimsCountSWRConfiguration = SWRConfiguration<HandlersSimCountResponse, SimsCountResultError>;

const useSimsCount = (
  filters: StructsSimRequestProperties,
  canLoad: boolean,
  onLoadingSlow?: SimsCountSWRConfiguration['onLoadingSlow']
) => {
  const key = canLoad
    ? {
        url: `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/count`,
        body: {
          ...filters,
        },
      }
    : null;

  const config: SimsCountSWRConfiguration = useSWRConfig();

  if (onLoadingSlow) {
    config.onLoadingSlow = onLoadingSlow;
  }

  const { data, error, isLoading, mutate, isValidating } = useSWR<
    HandlersSimCountResponse,
    SimsCountResultError
  >(key, postFetcher, config);

  return {
    count: data?.simCount ?? -1,
    isLoading,
    error,
    mutate,
    isValidating,
  };
};

export default useSimsCount;
